var FileDownload = require("js-file-download");
var moment = require("moment");
export const SET_GASTEN_VERBRUIK = "SET_GASTEN_VERBRUIK";
export const ADD_GASTEN_VERBRUIK = "ADD_GASTEN_VERBRUIK";
export const GASTEN_VERBRUIK_ERROR = "GASTEN_VERBRUIK_ERROR";
export const SET_GAST_VERBRUIK = "SET_GAST_VERBRUIK";
export const SET_VERBRUIK = "SET_VERBRUIK";
export const SET_GASTS = "SET_GASTS";
export const SET_GAST = "SET_GAST";
export const SET_TIPS = "SET_TIPS";
export const SET_TIP = "SET_TIP";
export const SET_GASTEN_PROFIEL = "SET_GASTEN_PROFIEL";
export const GET_GASTEN_PROFIEL = "GET_GASTEN_PROFIEL";
export const SET_ARTIKELEN = "SET_ARTIKELEN";
export const SET_ARTIKEL = "SET_ARTIKEL";
export const ARTIKEL_ERROR = "ARTIKEL_ERROR";
export const DELETE_GASTEN_VERBRUIK = "DELETE_GASTEN_VERBRUIK";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    return response.json().then((errorData) => {
      let error = new Error(response.statusText);
      error.data = errorData.errors;
      throw error;
    });
  }
}

function handleDownload(response) {
  if (response.ok) {
    return response.blob();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

export function set(results) {
  return {
    type: SET_GASTEN_VERBRUIK,
    results,
  };
}

export function get(results) {
  return {
    type: SET_GAST_VERBRUIK,
    results,
  };
}

export function setstam(results) {
  return {
    type: SET_GAST,
    results,
  };
}

export function getstam(results) {
  return {
    type: SET_GASTS,
    results,
  };
}

export function setverbruik(results) {
  return {
    type: SET_VERBRUIK,
    results,
  };
}

export function setone(results) {
  return {
    type: SET_GAST_VERBRUIK,
    results,
  };
}
export function add(results) {
  return {
    type: ADD_GASTEN_VERBRUIK,
    results,
  };
}

export function gettip(results) {
  return {
    type: SET_TIP,
    results,
  };
}

export function settips(results) {
  return {
    type: SET_TIPS,
    results,
  };
}

export function itemError(error) {
  return {
    type: GASTEN_VERBRUIK_ERROR,
    error,
  };
}

export function setgastenprofiel(results) {
  return {
    type: SET_GASTEN_PROFIEL,
    results,
  };
}

export function getgastenprofiel(results) {
  return {
    type: GET_GASTEN_PROFIEL,
    results,
  };
}

export function addgastengebruik(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      dispatch(add(results));
      return true;
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fetchgastenverbruik(query) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik?" + query, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(set(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fetchgastenverbruikone(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(get(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function deletegastverbruik(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/" + id, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(get(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function updategastengebruik(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(get(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function addgasten(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fetchasten() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(getstam(results.results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fetchonegasten(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results.result));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function updategasten(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results.results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fechduurzaamtips() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(settips(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fechoneduurzaamtips(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(gettip(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function inserteduurzaamtips(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips/", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(gettip(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function updateeduurzaamtips(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(gettip(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function addgastenprofiel(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setgastenprofiel(results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fechgastenprofiel() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(getgastenprofiel(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fechonegastenprofiel(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setgastenprofiel(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function updategastenprofiel(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(getgastenprofiel(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function copygastenprofiel(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel/copy", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setgastenprofiel(results));
    } catch (err) {
      return dispatch(itemError(err));
    }
  };
}

export function addgastengebruikmeter(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/meter", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function finishedboeking(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function addwkhboeking(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/addkwh/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function verplaatsboeking(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/verplaatsboeking/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fetchonemetreservering(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/metreservering/" + id, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results.result));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function changedatedepart(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/changedatedepart/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function uploadgasten(data) {
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("file", data.excel); // "file" is de key die je backend verwacht
      formData.append("gastenprofiel", data.gastenprofiel);
      

      const response = await fetch("/api/admin/stamgegevens/upload/", {
        method: "POST",
        body: formData,
        headers: {
          Authorization: localStorage.getItem("token"),
          // Let op: GEEN "Content-Type" hier, browser stelt automatisch multipart boundary in
        },
      });

      const results = await handleResponse(response);
      return dispatch(getstam(results));
    } catch (err) {
      return dispatch(itemError(err));
    }
  };
}

export function deletegast(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/" + id, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(getstam(results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function exportExcel(query) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/excel?"+query, {
        method: "get",

        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const blob = await handleDownload(response);
      const filename = `export_${moment().format("YYYYMMDD_HH:mm")}.xlsx`;
      FileDownload(blob, filename);
    } catch {
      dispatch(itemError("Bad Login Info"));
    }
  };
}

export function changeampere(id, data) {
    return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/changeampere/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function deleteReservering(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/reservering/" + id, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      dispatch({
        type: DELETE_GASTEN_VERBRUIK,
        id: id
      });
      return results;
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het verwijderen van de reservering"));
    }
  };
}

export function activeerReservering(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/activeren/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      dispatch(setone(results.results));
      return results;
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het activeren van de reservering"));
    }
  };
}

// Artikelen Actions
export function setArtikelen(results) {
  return {
    type: SET_ARTIKELEN,
    results,
  };
}

export function setArtikel(results) {
  return {
    type: SET_ARTIKEL,
    results,
  };
}

export function artikelError(error) {
  return {
    type: ARTIKEL_ERROR,
    payload: error,
  };
}

export function fetchArtikelen() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/artikelen", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikelen(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het ophalen van artikelen"));
    }
  };
}

export function fetchOneArtikel(id) {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/admin/gastenverbruik/artikelen/${id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikel(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het ophalen van het artikel"));
    }
  };
}

export function addArtikel(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/artikelen", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikel(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het toevoegen van het artikel"));
    }
  };
}

export function updateArtikel(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/admin/gastenverbruik/artikelen/${id}`, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikel(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het bijwerken van het artikel"));
    }
  };
}

export function deleteArtikel(id) {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/admin/gastenverbruik/artikelen/${id}`, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      await handleResponse(response);
      return dispatch(fetchArtikelen());
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het verwijderen van het artikel"));
    }
  };
}
